import ResultsPage from '@modules/serp/results-page'

import { forwardRef, type JSX } from 'react'

import type { JobItem, PaginatedResponse } from '@types'

import Pagination from '@components/pagination'

import Amount from './amount'
import SearchResultsHeader from './search-results-header'

import styles from './jobs-list.module.scss'

type JobsListProps = {
  onFiltersButtonClick: () => void
  paginationInfo: {
    page: number
    total: number
  }
  paginatedJobs?: PaginatedResponse<JobItem[]>
}

const JobsList = forwardRef<HTMLDivElement | null, JobsListProps>(
  ({ onFiltersButtonClick, paginatedJobs, paginationInfo }, ref): JSX.Element => {
    return (
      <div className={styles['search-results-container']} ref={ref}>
        <SearchResultsHeader
          onFiltersButtonClick={onFiltersButtonClick}
          location="jobs-list"
          paginationInfo={paginationInfo}
        />
        {!!paginatedJobs && paginatedJobs.content.length > 0 && (
          <>
            <ResultsPage page={1} items={paginatedJobs.content} />
            {!!paginatedJobs.totalPages && paginatedJobs.totalPages > 1 && (
              <Pagination totalPages={paginatedJobs.totalPages} />
            )}
            <Amount page={paginationInfo.page} total={paginationInfo.total} className={styles['bottom-amount']} />
          </>
        )}
      </div>
    )
  },
)

JobsList.displayName = 'JobsList'

export default JobsList
